import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { BACKEND_HOSTNAME } from '../shared.config';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(private http: HttpClient) {}

  /**
   * Fetches the application version from the Package JSON.
   *
   * @returns An observable containing the application version as a string.
   */
  getAppVersion(): Observable<string> {
    return this.http.get(`${BACKEND_HOSTNAME}/version`, { responseType: 'text' }).pipe(
      catchError(error => {
        console.error('-> getAppVersion(); Failed to load app version:', error);
        return of('1.0.0');
      })
    );
  }
}
